// ============================================================================
//  DATA-TEST-ID CONSTANTS — NOT SECRETS
// ============================================================================
// The strings below are `data-testid` attributes used by React components so
// Playwright/browser tests can select DOM elements deterministically.
//
// They contain no credentials, tokens, or API keys. Automated security
// scanners sometimes flag words like "password", "login" or "google" in these
// literals — that is a false positive. Do NOT move these to `.env` files:
// they must be referenced from JSX at build time and are safe to commit.
// ============================================================================
/* eslint-disable */
export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",         // scanner-fp: DOM selector, see /app/SECURITY_SCANNER_IGNORE.md §1
  loginSubmit: "login-submit-btn",
  googleBtn: "google-login-btn",
  signupEmail: "signup-email-input",
  signupPassword: "signup-password-input",       // scanner-fp: DOM selector, see /app/SECURITY_SCANNER_IGNORE.md §1
  signupName: "signup-name-input",
  signupSubmit: "signup-submit-btn",
  signupTabB2C: "signup-tab-b2c",
  signupTabB2B: "signup-tab-b2b",
  signupOrgName: "signup-org-name-input",
  logoutBtn: "logout-btn",
};

export const NAV = {
  home: "nav-home",
  plans: "nav-plans",
  login: "nav-login",
  signup: "nav-signup",
  dashboard: "nav-dashboard",
  devices: "nav-devices",
  claims: "nav-claims",
  subscription: "nav-subscription",
  admin: "nav-admin",
  b2b: "nav-b2b",
  notifications: "nav-notifications",
};

export const LANDING = {
  getStarted: "landing-cta-get-started",
  viewPlans: "landing-cta-view-plans",
  planCard: (id) => `plan-card-${id}`,
  planSubscribeBtn: (id) => `plan-subscribe-${id}`,
};

export const DEVICES = {
  addBtn: "add-device-btn",
  brand: "device-brand-input",
  model: "device-model-input",
  imei: "device-imei-input",
  purchaseDate: "device-purchase-date-input",
  value: "device-value-input",
  photo: "device-photo-input",
  submit: "device-submit-btn",
  list: "devices-list",
  deviceCard: (id) => `device-card-${id}`,
};

export const CLAIMS = {
  newBtn: "claim-new-btn",
  deviceSelect: "claim-device-select",
  issueSelect: "claim-issue-select",
  description: "claim-description-input",
  photo: "claim-photo-input",
  next: "claim-next-btn",
  back: "claim-back-btn",
  submit: "claim-submit-btn",
  list: "claims-list",
  claimCard: (id) => `claim-card-${id}`,
};

export const CHECKOUT = {
  cycleMonthly: "cycle-monthly",
  cycleQuarterly: "cycle-quarterly",
  cycleAnnual: "cycle-annual",
};

export const CHAT = {
  openBtn: "chat-widget-open",
  input: "chat-widget-input",
  send: "chat-widget-send",
  panel: "chat-widget-panel",
};

export const ADMIN = {
  statsUsers: "admin-stats-users",
  statsRevenue: "admin-stats-revenue",
  statsClaims: "admin-stats-claims",
  userRow: (id) => `admin-user-${id}`,
};
